<template>
  <a-config-provider :locale="locale">
    <div>
      <router-view></router-view>
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
export default {
  name: 'App',
  created() {

  },
  data() {
    return {
      locale: zhCN,
    };
  },
}
</script>

<style lang='less'>
@import "@/assets/css/index.less";
</style>
